module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-map', {
    attrs: {
      "mapFile": "contig_us.geo.json",
      "dataFile": "all_load.csv",
      "res": "Shasta Dam",
      "resFile": "all_resv.json",
      "hasKey": _vm.hasKey,
      "whichState": "none"
    }
  }), _vm._v(" "), _c('snow-chart', {
    attrs: {
      "whichState": "main"
    }
  }), _vm._v(" "), _c('drought-map', {
    attrs: {
      "mapFile": "western_us.json",
      "centersFile": "all_centers.json",
      "dataFile": "all.csv"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a841894"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main.vue
// module id = 366
// module chunks = 1